module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/232-yemen-f3897018cc2ed4fbbc1e2325ee3a2f1f.svg";